import { Formik, Form, Field } from "formik";
import { FormModel } from "../types/FormTypes";
import { useAtom } from "jotai";
import { formDataAtom } from "../App";
import { useNavigate } from "react-router-dom";
import * as Yup from "yup";
import Box from "../components/Box/Box";
import Progressbar from "../components/Progressbar/Progressbar";
import ErrorList from "../components/Form/ErrorList";
import { useRef } from "react";
import { handleSubmitClick } from "../components/Form/FormUtils";
import BackButton from "../components/Buttons/BackButton";
import useFocusOnLoad from "../hooks/useFocusOnLoad";
import InputText from "../components/Form/InputText";
import SelectInput from "../components/Form/SelectInput";

export const radiotest_TICKET = "ticket";
export const radiotest_TAXI = "taxi";
export const radiotest_CAR = "car";

export default function ContactDetails() {
    const h2Ref = useFocusOnLoad<HTMLHeadingElement>();
    const [formData, setFormData] = useAtom(formDataAtom);
    const navigate = useNavigate();
    const formRef = useRef<HTMLFormElement>(null);
    const atLeastSixDigits = /\d{6,}/;
    const noDigits = /^[^\d]*$/;

    return (
        <div>
            <Formik<FormModel>
                onSubmit={(values) => {
                    setFormData({
                        ...formData,
                        ...values,
                    });

                    navigate("/summering");

                }}
                initialValues={{
                    ...formData,
                }}
                enableReinitialize
                validateOnChange={false}
                validateOnBlur={false}
                
                validationSchema={Yup.object().shape({                   
                    travelQty: Yup.string().required("Vänligen ange antal resenärer"),
                    contactperson: Yup.string()
                        .required("Vänligen ange namn på kontaktperson")
                        .matches(noDigits, "Namnet får inte innehålla siffror"),
                    phonenumberschoolorg: Yup.string()
                        .required("Vänligen ange telefonnummer")
                        .matches(atLeastSixDigits, "Telefonnumret måste innehålla minst 6 siffror"),
                    mailadress: Yup.string()
                        .required("Vänligen ange mejladress")
                        .email("Vänligen ange en korrekt mejladress"),
                    phonenumber: Yup.string()
                        .required("Vänligen ange telefonnummer")
                        .matches(atLeastSixDigits, "Telefonnumret måste innehålla minst 6 siffror"),
                })}

            >
                {({ errors, values }) => (
                    <>
                        <div className="flex justify-end items-center">
                            <div className="xs:w-52 md:w-full max-w-xs">
                                <Progressbar percentage={"64"} />
                            </div>
                        </div>
                        <Form noValidate>
                            <Box>
                                <h2 className="mb-8" ref={h2Ref} tabIndex={-1} id="contactsDetailsHeading">Vilka är ni som ska resa?</h2>

                                <h3>Bra att tänka på</h3>
                                <ul className="mb-8">
                                    <li>
                                        Rullstol och barnvagn kan bara tas med i mån av plats.
                                    </li>
                                    <li>
                                        Reser ni med kulturbiljetten får upp till 30 personer resa på biljetten, varav minst 1 och max 4 personer ska vara vuxna.
                                    </li>
                                </ul>

                                {Object.keys(errors).length > 0 && <ErrorList errors={errors} />}

                                <InputText
                                    name="schoolorg"
                                    label={<>Skola/Organisation <span>(Frivilligt)</span></>}
                                    type="text"
                                    autocomplete={"text"}
                                />

                                <SelectInput
                                    name="travelQty"
                                    label={<>Antal resande <span>(Obligatoriskt)</span></>}
                                    options={Array.from({ length: 30 }, (_, i) => i + 1)}
                                />

                                <InputText
                                    name="contactperson"
                                    label={<>Kontaktperson <span>(Obligatoriskt)</span></>}
                                    type="text"
                                    autocomplete={"text"}
                                />

                                <InputText
                                    name="phonenumberschoolorg"
                                    label={<>Telefonnummer <span>(Obligatoriskt)</span></>}
                                    type="text"
                                    autocomplete={"text"}
                                    numbersOnly
                                />

                                <InputText
                                    name="mailadress"
                                    label={<>Mejladress <span>(Obligatoriskt)</span></>}
                                    type="email"
                                    autocomplete={"email"}
                                />

                                <h3>Hur når vi er under resan?</h3>

                                <p>
                                    Vi behöver ett telefonnummer till någon som ska vara med på resan, ifall vi skulle behöva komma i kontakt med er under resdagen.
                                </p>

                                <InputText
                                    name="phonenumber"
                                    label={<>Telefonnummer <span>(Obligatoriskt)</span></>}
                                    type="text"
                                    numbersOnly
                                    autocomplete={"text"}
                                />
                            </Box>

                            <div className="flex justify-center">
                                <div className="w-full text-left flex items-center">
                                    <BackButton />
                                </div>
                                <div className="w-full text-right">
                                    <button
                                        onClick={handleSubmitClick(formRef)}
                                        className="btn primary"
                                        type="submit"
                                    >
                                        Gå vidare
                                    </button>
                                </div>
                            </div>

                        </Form>
                    </>
                )}
            </Formik>
        </div>
    );
}
